// Rellena aquí las fechas de nacimiento reales en formato YYYY-MM-DD.
export const STREAMERS = {
	alvaro: { birthDate: '2000-09-24' },
	daniel: { birthDate: '2000-01-29' },
	chanchex: { birthDate: '1999-09-04' }
};

export function calculateAge(birthDate, today = new Date()) {
	const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthDate);
	if (!match) throw new Error(`Fecha de nacimiento no válida: ${birthDate}`);

	const [, yearText, monthText, dayText] = match;
	const year = Number(yearText);
	const month = Number(monthText);
	const day = Number(dayText);
	const parsedDate = new Date(Date.UTC(year, month - 1, day));

	if (
		parsedDate.getUTCFullYear() !== year ||
		parsedDate.getUTCMonth() + 1 !== month ||
		parsedDate.getUTCDate() !== day
	) {
		throw new Error(`Fecha de nacimiento no válida: ${birthDate}`);
	}

	let age = today.getUTCFullYear() - year;
	const hasHadBirthday =
		today.getUTCMonth() + 1 > month ||
		(today.getUTCMonth() + 1 === month && today.getUTCDate() >= day);

	if (!hasHadBirthday) age -= 1;
	if (age < 0) throw new Error(`La fecha de nacimiento está en el futuro: ${birthDate}`);

	return age;
}

export function getStreamerAge(streamer, today = new Date()) {
	const birthDate = STREAMERS[streamer]?.birthDate;
	if (!birthDate) throw new Error(`Streamer no configurado: ${streamer}`);

	return calculateAge(birthDate, today);
}
